import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../core/routes/routes";
import { DateUtil } from "../../common/utils/date.util";
import { useCallToAttentionQuery } from "./hooks/useCallToAttentionQuery.js";
import { useCallToAttentionCommand } from "./hooks/useCallToAttentionCommand.js";
import Table from "../../common/components/Table";
import Textfield from "../../common/components/Textfiled";
import Pagination from "../../common/components/Pagination";
import CardNumber from "../../common/components/CardNumber";
import IconButton from "../../common/components/IconButton";
import FormCallToAttention from "./components/FormCallToAttention";
import { BsClipboardPlus, BsPencilSquare, BsTrash } from "react-icons/bs";

function ListCallToAttention() {
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    search: "",
  });
  const {
    callToAttention,
    currentPage,
    loading,
    onChangePage,
    totalPages,
    total,
    refresh,
  } = useCallToAttentionQuery(filters);

  const {
    callToAttention: callToAttentionForm,
    handleChange,
    setDefaultValues,
    updateCallToAttention,
    deleteCallToAttention,
    errors,
    loading: commandLoading,
  } = useCallToAttentionCommand(refresh);

  const [showEditModal, setShowEditModal] = useState(false);

  const handleEdit = (item) => {
    setDefaultValues(item);
    setShowEditModal(true);
  };

  const handleUpdate = async () => {
    await updateCallToAttention();
    setShowEditModal(false);
  };

  const columns = [
    { header: "Nombre del llamado", accessor: "nameCautioned" },
    {
      header: "Identificación del llamado",
      accessor: "identificationCautioned",
    },
    { header: "Razón del llamado", accessor: "reason" },
    {
      header: "Fecha",
      accessor: "date",
      render: (value) => DateUtil.format(value, "DD/MM/YYYY"),
    },
    { header: "Tipo de llamado", accessor: "type" },
    { header: "Estado", accessor: "status" },
    { header: "Observaciones", accessor: "observations" },
    {
      header: "Documento",
      accessor: "document",
      render: (value) =>
        value ? (
          <a href={value} target="_blank" rel="noopener noreferrer">
            Ver PDF
          </a>
        ) : (
          ""
        ),
    },
    {
      header: "Fecha de creación",
      accessor: "createdAt",
      render: (value) => DateUtil.format(value, "DD/MM/YYYY"),
    },
    {
      header: "Acciones",
      accessor: "actions",
      render: (_, item) => (
        <div className="d-flex align-items-center gap-2">
          <IconButton tooltipText="Editar" onClick={() => handleEdit(item)}>
            <BsPencilSquare size={20} />
          </IconButton>
          <IconButton
            tooltipText="Eliminar"
            onClick={() => deleteCallToAttention(item.id)}
          >
            <BsTrash size={20} color="#dc3545" />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <main className="container-fluid p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Lista de llamados de atención</h1>
        <div className="d-flex gap-2">
          <IconButton
            tooltipText="Registrar"
            onClick={() => navigate(ROUTES.REGISTER_CALL_TO_ATTENTION)}
          >
            <BsClipboardPlus size={24} />
          </IconButton>
        </div>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3 flex-wrap flex-md-nowrap">
          <div className="w-100">
            <Textfield
              label="Buscar"
              name="search"
              onChange={({ value }) =>
                setFilters({ ...filters, search: value })
              }
              placeholder="Buscar..."
              value={filters.search}
            />
          </div>

          <div className="d-flex gap-2 flex-wrap flex-md-nowrap justify-content-center">
            <Textfield
              label="Fecha"
              type="date"
              name="startDate"
              value={filters.startDate}
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, startDate: value }))
              }
            />
            <Textfield
              label="Fecha"
              type="date"
              name="endDate"
              value={filters.endDate}
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, endDate: value }))
              }
            />
          </div>
          <div className="mx-auto">
            <CardNumber number={total} size="md" />
          </div>
        </div>

        <Table
          columns={columns}
          data={callToAttention}
          showIndex={true}
          loading={loading}
        />

        <Pagination
          onChangePage={onChangePage}
          page={currentPage}
          totalPages={totalPages}
        />
      </section>

      {showEditModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
          onClick={() => setShowEditModal(false)}
        >
          <div
            className="bg-white rounded shadow p-4"
            style={{ maxWidth: 700, width: "100%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="mb-3">Editar llamado de atención</h3>
            <FormCallToAttention
              callToAttention={callToAttentionForm}
              onChange={handleChange}
              errors={errors}
              onSubmit={handleUpdate}
              submitLabel="Actualizar"
              loading={commandLoading}
            />
            <div className="d-flex justify-content-end mt-2">
              <button
                className="btn btn-secondary"
                onClick={() => setShowEditModal(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default ListCallToAttention;
